export default __webpack_public_path__ + "static/media/iceWall.862c9407.png";